<template>
    <div class="advocacyCont" v-if="themes && themes.length > 0">
        <h2 class="baron headerText">advocacy</h2>
        <div class="themes">
            <div class="theme" v-for="theme in themes">
                <h3 class="title3 helvetica">{{ theme.title }}</h3>
                <div class="summary">{{ theme.summary }}</div>
                <div class="plusCont">
                    <IconPlus />
                </div>
                <NuxtLink class="overlink" :to="{ name: 'advocacy-theme', params: { theme: theme.url } }" :aria-label="theme.title"></NuxtLink>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
defineProps<{ themes: any[] }>()
</script>

<style lang="scss" scoped>
.advocacyCont {
    margin: 0 var(--size-margin-page);
    padding-bottom: var(--size-gutter-sections);

    display: flex;
    flex-direction: column;
    gap: var(--size-gutter-double);


    h2 {
        border-top: var(--size-thickness) solid var(--color-primary);
        font-weight: normal;
        color: var(--color-primary);
        padding-top: var(--size-margin-page);
    }

    .themes {
        display: flex;
        flex-direction: column;
        gap: var(--size-gutter-small);

        .theme {
            position: relative;
            background-color: var(--color-sand);
            padding: var(--size-gutter-default) 0;
            color: var(--color-primary);

            display: grid;
            grid-template-columns: 5fr 5fr 2fr;
            gap: var(--size-gutter-default);

            transition: background-color 300ms 0ms cubic-bezier(.4, 0, .2, 1), color 300ms 0ms cubic-bezier(.4, 0, .2, 1);

            h3 {
                padding-left: var(--size-gutter-default);
            }

            .plusCont {
                display: flex;
                justify-content: flex-end;
                padding-right: var(--size-gutter-default);
            }

            &:hover {
                background-color: var(--color-primary);
                color: white;

                &:deep(svg) {
                    path {
                        fill: white;
                    }
                }
            }
        }
    }
}

@media screen and (max-width: 600px) {
    .advocacyCont {
        width: 100%;
        overflow: hidden;

        margin-bottom: calc(0px - var(--size-gutter-sections));
        margin-left: 0;

        h2 {
            margin: 0 var(--size-margin-page);
        }

        .themes {
            flex-direction: row;
            gap: 0;

            overflow-x: auto;
            overflow-y: hidden;
            scroll-snap-type: x mandatory;
            scrollbar-width: none;
            -ms-overflow-style: none;

            scroll-behavior: smooth;
            -webkit-overflow-scrolling: touch;

            &::-webkit-scrollbar {
                display: none;
            }

            padding-bottom: var(--size-gutter-sections);
            padding-right: 200px;

            .theme {
                grid-template-columns: 1fr;
                grid-template-rows: min-content 1fr min-content;
                padding: var(--size-gutter-default);
                border-left: var(--size-margin-page) solid white;

                scroll-snap-align: start;
                width: calc(100vw - 200px);
                height: 380px;
                flex-shrink: 0;

                h3,
                .plusCont {
                    padding: 0;
                }
            }
        }
    }
}
</style>